import { BaseItemModel } from "@webapp/core/abstracts/models/base-item.model";

export class MultiAccount extends BaseItemModel {
  public accountId: string;
  public accountName: string;
  public accountDomain: string;
  public userId: string;
  public userIsPrimary: boolean;
  public invitation?: UserMultiAccountInvitation;
}

export class MultiAccountDTO extends BaseItemModel {}

export class UserMultiAccountInvitation extends BaseItemModel {
  public id: string;
  public invitedByEmail: string;
  public invitedByNames: string;
  public invitedOn: string;
  public status: UserMultiAccountInvitationType;
}

export enum UserMultiAccountInvitationType {
  pending,
  approved,
  rejected,
}
